import { useState, useEffect } from "react";
import useContract from "../../../hooks/useContract";
import useWallet from "../../../hooks/Wallet/useWallet";
import{ethers} from 'ethers'
import { getHistory, getEarnReward, getLotterySum } from "../../../api";
import { getFix2, big2num, date2block, handlerWalletTxError} from "../../../utils/utils";
import {
  getUnharvestReward,
  getLotteryRecords,
} from "../../../contract/useRunbit";
import useGlobal from "../../../hooks/useGlobal";
import { Toast } from "antd-mobile";
import { useIntl } from "react-intl";
import useCommon from "../../../hooks/Common/useCommon";
export default function useAccount() {
  const intl = useIntl();
  const {
    getRBBalance,
    getRBCTBalance,
    getRBETBalance,
    getUSDTBalance,
    getRunContract,
  } = useContract();
  const { myAccount, runContract } = useWallet();
  const { showLoading, getTxOptions } = useGlobal();
  const { lang } = useCommon();
  const getHistoryRecord = async () => {
    //已领取记录
    return await getHistory({
      addr: myAccount.account,
      lang: lang === "en" ? "en" : "cn",
    });
  };
  const getBalances = async () => {
    let RB = await getRBBalance();
    console.log('RB',RB,big2num(RB))
    RB = getFix2(big2num(RB));
    const RBCT = await getRBCTBalance();
    const RBET = await getRBETBalance();
    let USDT = await getUSDTBalance();
    console.log("USDT", USDT,RB);
    // USDT = getFix2(big2num(USDT))
    const bs = {
      RB,
      RBCT,
      RBET,
      USDT,
    };
    return bs;
  };

  //未领取收益
  const getUnclaimReward = async () => {
    const contract = await getRunContract();

    const amount = await contract.getUnclaimReward(myAccount.account);
    console.log("getUnclaimReward", amount);
    return amount;
  };
  //已领取收益
  const getClaimedReward = async () => {
    const res = await getEarnReward(myAccount.account);
    console.log("getClaimedReward", res);
    return res.data;
  };
  // 收益记录
  const getHavestRecord = async (start, end) => {
    return getUnharvestReward(myAccount.account, end, start);
  };

  const getLotteries = async (start, end) => {
    return getLotteryRecords(myAccount.account, end, start);
  };

  const getLotteryStatistics = async () => {
    return getLotterySum(myAccount.account);
  };

  const claimLotteryReward = async (item) => {
    showLoading(
      intl.formatMessage({
        id: "pages.account.lottery_notice_preparing",
        defaultMessage: "領取中...",
      })
    );
  
    try {
      const contract = await getRunContract();
      const gaslimit = await contract.estimateGas.lottery(
        item.day
      );
      const opts = await getTxOptions(gaslimit)
      console.log('claimLotteryReward',item.day,opts);
      const tx = await contract.lottery(item.day, opts);
      await tx.wait(3);
      Toast.show({
        content: intl.formatMessage({
          id: "pages.account.lottery_notice_success",
          defaultMessage: "領取成功",
        }),
        icon: "success",
      });
    } catch (e) {
      const reason = handlerWalletTxError(e,intl)
      const error =  intl.formatMessage({
        id: "common.operation_fail",
        defaultMessage: "操作失败: ",
      })
      Toast.show({
        content: error + ':' + reason,
        icon: "fail",
      });
      // return Promise.reject();
    }
  };

  const claimProfit = async (unclaim) => {
    showLoading(
      intl.formatMessage({
        id: "pages.account.claiming",
        defaultMessage: "正在领取...",
      })
    );
    
    try {
      const contract = await getRunContract();
      const gaslimit = await contract.estimateGas.claim(
        unclaim, myAccount.account
      );
      const opts = await getTxOptions(gaslimit)
      console.log('claimProfit',unclaim,opts)
      let tx = await contract.claim(unclaim, myAccount.account,opts);

      await tx.wait(2)
      Toast.show({
        content: intl.formatMessage({
          id: "pages.account.claim_success",
          defaultMessage: "领取成功",
        }),
        icon: "success",
      });
   
    } catch (e) {
      const reason = handlerWalletTxError(e,intl)
      const error =  intl.formatMessage({
        id: "common.operation_fail",
        defaultMessage: "操作失败: ",
      })
      Toast.show({
        content: error + ':' + reason,
        icon: "fail",
      });
      // return Promise.reject()
    }
  };

  const harvestProfitByDay = async (day) => {
    showLoading(
      intl.formatMessage({
        id: "pages.account.harvesting",
        defaultMessage: "正在收穫...",
      })
    );
    try {
      const contract = await getRunContract();
      const gaslimit = await contract.estimateGas.claimBonus(
        day
      );
      const opts = await getTxOptions(gaslimit)
      console.log('harvestProfitByDay',day,opts);
      let tx = await contract.claimBonus(day,opts);

      await tx.wait(2)
        Toast.show({
          content: intl.formatMessage({
            id: "pages.account.harvest_success",
            defaultMessage: "收穫成功",
          }),
          icon: "success",
        });
    } catch (e) {
      const reason = handlerWalletTxError(e,intl)
      const error =  intl.formatMessage({
        id: "common.operation_fail",
        defaultMessage: "操作失败: ",
      })
      Toast.show({
        content: error + ':' + reason,
        icon: "fail",
      });
      return Promise.reject();
    }
  };

  const harvestProfitByDateRange = async (startDay, endDay) => {
    showLoading(
      intl.formatMessage({
        id: "pages.account.harvesting",
        defaultMessage: "正在收穫...",
      })
    );
    console.log(startDay, endDay);
    try {
      const contract = await getRunContract();
      const gaslimit = await contract.estimateGas.harvest(
        startDay, endDay
      );
      const opts = await getTxOptions(gaslimit)
      console.log('harvestProfitByDateRange')
      console.log(startDay, endDay,opts)
      let tx = await contract.harvest(startDay, endDay,opts);

      await tx.wait(2)
        Toast.show({
          content: intl.formatMessage({
            id: "pages.account.harvest_success",
            defaultMessage: "收穫成功",
          }),
          icon: "success",
        });
      
    } catch (e) {
      const reason = handlerWalletTxError(e,intl)
      const error =  intl.formatMessage({
        id: "common.operation_fail",
        defaultMessage: "操作失败: ",
      })
      Toast.show({
        content: error + ':' + reason,
        icon: "fail",
      });
      // return Promise.reject()
    }
  };
  return {
    myAccount,
    getBalances,
    getHistoryRecord,
    getUnclaimReward,
    getClaimedReward,
    getHavestRecord,
    getLotteryStatistics,
    getLotteries,
    claimLotteryReward,
    claimProfit,
    harvestProfitByDay,
    harvestProfitByDateRange,
  };
}
